import { logout } from 'shared/auth';
import { Icon } from 'shared/ui/Icon';
import { IconButton } from 'shared/ui/IconButton';

export const Logout = () => (
  <IconButton onClick={() => logout()}>
    <Icon width='28px' name='logout' />
  </IconButton>
);
